import React from 'react';

import { useGoogleApi } from './GoogleProvider';

export const useLoginButton = () => {
  const buttonRef = React.useRef(null);
  const { ready } = useGoogleApi();
  React.useEffect(() => {
    if (ready) {
      try {
        window.google.accounts.id.renderButton(buttonRef.current, {
          theme: 'outline',
          width: 272,
        });
      } catch (e) {}
    }
  }, [ready]);
  return buttonRef;
};
